module.exports = __webpack_public_path__ + "static/media/generateleads.32e19384.png";